export const SENDGRID_MAILFROM1 = process.env.REACT_APP_SENDGRID_MAILFROM;
export const SITE_ADRESS = process.env.REACT_APP_SITE_ADRESS;
